const openRoutes = ["/login", "/verify", "/payments", "/privacy-policy", "/app-links", "session-expiry"];

const isOpenRoute = (route: string) => {
  return openRoutes.includes(route);
}

export { isOpenRoute }